var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTzs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51544 20.7534C4.01883 21.2568 4.55592 21.7057 5.11931 22.101L21.8335 5.38669C21.4384 4.8233 20.9894 4.28621 20.486 3.78282C19.9826 3.27943 19.4455 2.83055 18.8821 2.4353L2.16797 19.1496C2.56313 19.7128 3.01209 20.25 3.51544 20.7534Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51422 3.7815C-0.271495 7.56731 -0.998292 13.2528 1.33247 17.7689L17.5016 1.5998C12.9856 -0.730968 7.29999 -0.00412455 3.51422 3.7815Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4854 20.7508C24.2711 16.9651 24.9979 11.2795 22.6672 6.76343L6.49805 22.9326C11.014 25.2634 16.6996 24.5366 20.4854 20.7508Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTzs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TZS.171f72ba28c89e4246495fc2d22a9865.svg";